import {
  useMutation,
  useQuery,
  useQueryClient,
  useInfiniteQuery,
} from "react-query";
import {
  addCartkhanFactorPurchase,
  addCartkhanPaymentOperation,
  addCartkhanRecieveOperation,
  addCheckFactor,
  addCheckFactorPurchase,
  addCheckPaymentOperation,
  addCheckPaymentSell,
  addCheckRecieveOperation,
  addCost,
  addFactorAutoPurchase,
  addFactorPurchaseCustom,
  addHavaleFactorPurchase,
  addHavaleHesab,
  addHavalePaymentOperation,
  addHavaleRecieveOperation,
  addNaghdiFactor,
  addNaghdiFactorPurchase,
  addNaghdiPaymentOperation,
  addNewAnbar,
  addNewCheck,
  addNewCheckBack,
  addNewIncome,
  addNewUser,
  addOrderOffline,
  changeCheckStatus,
  changeStatusOrderOnlineActive,
  changeStatusOrderOnlineComplete,
  changeStatusOrderOnlineOkPay,
  changeStatusSmsList,
  confirmFactor,
  confirmReturnOnSale,
  conversionToFactor,
  deleteAnbar,
  deleteCheck,
  deleteCheckPaymentSell,
  deleteCost,
  deleteDetailOrderOnline,
  deleteFactorItemRecievePayment,
  deleteIncome,
  deleteNotConfirmedOrderOnline,
  deleteOneOrderOnline,
  deleteOrderOnline,
  deleteOrderReturnOnSale,
  deletePaymentItemOperation,
  deletePreInvoice,
  deletePurchaseItem,
  deletePurchaseProduct,
  deleteSandadDaryaft,
  deleteUser,
  detailRecieveOperation,
  editReturnOnSale,
  finalConfirm,
  finalConformPurchaseCutom,
  geDetailUser,
  getAccessHavaleStatus,
  getAllCheckList,
  getAllCost,
  getAllFactor,
  getAllIcomeList,
  getAllOderOnline,
  getAllOfChecks,
  getAllOrderOffline,
  getApprovedOnlinOrder,
  getAvaiableCheck,
  getBackCheck,
  getBankDetail,
  getCashDetail,
  getCheckDetail,
  getCheckPaidDetail,
  getCheckUpdate,
  getDashboard,
  getDeliverOrderOnline,
  getDetailOderOnline,
  getDetailSmsManagement,
  getFactor,
  getFinalPrint,
  getListAnbar,
  getListDocumentFactor,
  getListFactorPurchase,
  getListHavaleHesab,
  getListOperation,
  getListOrderOfflinesAndListOrderOnlines,
  getListPaymentChecklist,
  getListPaymentOperation,
  getListPreInvoice,
  getListPurchaceFactorCustom,
  getListPurchase,
  getListRecieveChecklist,
  getListReturnOnSale,
  getListSellPayment,
  getListSmsManagement,
  getNotOkCustomerOrderOnline,
  getNotPaymentOrderOnline,
  getOkCustomerOrderOnline,
  getResponeCheck,
  getSupplierList,
  insertDetailOrderOnlineNumberProduct,
  listReturnOnSale,
  listUser,
  nonPortalPayment,
  productOrderOnline,
  recieveOperation,
  returnOnSale,
  searchPreInvoice,
  updateAnbar,
  updateCardkhan,
  updateCheck,
  updateCheckFactor,
  updateCheckSell,
  updateCost,
  updateDetailOnlineNumberProduct,
  updatedOrderOffline,
  updatedUser,
  updateHavale,
  updateHavaleCheck,
  updateIncome,
  updateNaghdiCheck,
  updateNaghdiFactor,
  updateNaghdiPaymentOperation,
  updatePurchaseCartkhan,
  updatePurchaseCheck,
  updatePurchaseHavale,
  updatePurchasenaghdi,
  updatePurchaseProduct,
  updateSmsPanel,
} from "../services/accounting";
import { errorMessage, successMessage } from "../utils/message";

// get all orders online
export const useAllOrdersOnline = (pageNumber, search) =>
  useInfiniteQuery(
    ["all-online-order", pageNumber, search],
    ({ pageParam = 1 }) => getAllOderOnline(pageParam, search),
    {
      getNextPageParam: (lastPage, allPages) => {
        return allPages.length + 1;
      },
    }
  );
// useQuery(["all-online-order", pageNumber], () =>
//   getAllOderOnline(pageNumber)
// );

// get use not approve order online
export const useNotApprovedOrderOnline = (pageNumber) =>
  useInfiniteQuery(
    ["approve-online-order", pageNumber],
    ({ pageParam = 1 }) => getApprovedOnlinOrder(pageParam),
    {
      getNextPageParam: (lastPage, allPages) => {
        return allPages.length + 1;
      },
    }
  );
// useQuery(["approve-online-order", pageNumber], () =>
//   getApprovedOnlinOrder(pageNumber)
// );

// get not payment order online
export const useNotPaymentOrderOnline = (pageNumber) =>
  useInfiniteQuery(
    ["payment-online-order", pageNumber],
    ({ pageParam = 1 }) => getNotPaymentOrderOnline(pageParam),
    {
      getNextPageParam: (lastPage, allPages) => {
        return allPages.length + 1;
      },
    }
  );

// get to deliverer order online
export const useNotDelivererOrderOnline = (pageNumber) =>
  useInfiniteQuery(
    ["deliverer-online-order", pageNumber],
    ({ pageParam = 1 }) => getDeliverOrderOnline(pageParam),
    {
      getNextPageParam: (lastPage, allPages) => {
        return allPages.length + 1;
      },
    }
  );

// get not ok customer order online
export const useNotOkCustomerOrderOnline = (pageNumber) =>
  useInfiniteQuery(
    ["not-customer-online-order", pageNumber],
    ({ pageParam = 1 }) => getNotOkCustomerOrderOnline(pageParam),
    {
      getNextPageParam: (lastPage, allPages) => {
        return allPages.length + 1;
      },
    }
  );

// get ok customer order online
export const useOkCustomerOrderOnline = (pageNumber) =>
  useInfiniteQuery(
    ["ok-customer-online-order", pageNumber],
    ({ pageParam = 1 }) => getOkCustomerOrderOnline(pageParam),
    {
      getNextPageParam: (lastPage, allPages) => {
        return allPages.length + 1;
      },
    }
  );
// useQuery(["ok-customer-online-order", pageNumber], () =>
//   getOkCustomerOrderOnline(pageNumber)
// );

// ---------------------------Detail--------------------
// get order detail online
export const useDetailOrdersOnline = (idOrderOnline) =>
  useQuery(["detail-online-order", idOrderOnline], () =>
    getDetailOderOnline(idOrderOnline)
  );

// change status order online okay and pay
export const useChangeStatusOkPay = () =>
  useMutation(changeStatusOrderOnlineOkPay, {
    onSuccess: () => {
      successMessage("عملیات با موفقیت انجام شد");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });

// change status order online complete
export const useChangeStatusComplete = () =>
  useMutation(changeStatusOrderOnlineComplete, {
    onSuccess: () => {
      successMessage("عملیات با موفقیت انجام شد");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });

// change status order online active
export const useChangeStatusActive = () =>
  useMutation(changeStatusOrderOnlineActive, {
    onSuccess: () => {
      successMessage("عملیات با موفقیت انجام شد");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });

// update Detail Online Number Product;
export const useUpdateDetailNumberProduct = () =>
  useMutation(updateDetailOnlineNumberProduct, {
    onSuccess: () => {
      successMessage("عملیات با موفقیت انجام شد");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });

// getting product list
export const useGetProductList = () =>
  useQuery("product-list", () => productOrderOnline());

// insert detail order product
export const useInsertDetailOrderProduct = () =>
  useMutation(insertDetailOrderOnlineNumberProduct, {
    onSuccess: () => {
      successMessage("عملیات با موفقیت انجام شد");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });

// delete detail order online
export const useDeleteOrderOnline = () =>
  useMutation(deleteDetailOrderOnline, {
    onSuccess: () => {
      successMessage("عملیات با موفقیت انجام شد");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });

// delete one order online
export const useDeleteOneOrderOnline = () =>
  useMutation(deleteOneOrderOnline, {
    onSuccess: () => {
      successMessage("عملیات با موفقیت انجام شد");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });

// list user
export const useListUser = (PageNumber) =>
  useQuery(["list-user", PageNumber], () => listUser(PageNumber), {
    keepPreviousData: true,
    staleTime: 5000,
  });

export const useDetailUser = (IdPerson) =>
  useQuery("detail-person", () => geDetailUser(IdPerson));

// add new user
export const useAddNewUser = () =>
  useMutation(addNewUser, {
    onSuccess: () => {
      successMessage("شخص جدید با موفقیت درج شد");
    },
    onError: (err) => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });

// update user
export const useUpdateUser = () =>
  useMutation(updatedUser, {
    onSuccess: () => {
      successMessage("با موفقیت آپدیت شد");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });

// delete a user
export const useDeleteUser = () => {
  const queryClient = useQueryClient();
  return useMutation(deleteUser, {
    onSuccess: () => {
      queryClient.invalidateQueries("first-files");
      successMessage("کاربر با موفیت حذف شد");
    },
    onError: () => {
      errorMessage("این کاربر پرونده دارد");
    },
  });
};

// -----------------------Order Offline

// insert order offline
export const useInsertOrderOffline = () =>
  useMutation(addOrderOffline, {
    onSuccess: () => {
      successMessage("محصول با موفقیت ثبت شد");
    },
    onError: () => {
      errorMessage("لطفا فیلدهای مورد نظر را پر کنید.");
    },
  });

// delete order offline
export const useDeleteOrderOffline = () =>
  useMutation(deleteOrderOnline, {
    onSuccess: () => {
      successMessage("فاکتور با موفقیت حذف شد");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });

// update order offline
export const useUpdateOrderOffline = () =>
  useMutation(updatedOrderOffline, {
    onSuccess: () => {
      successMessage("فاکتور با موفقیت ویرایش شد");
    },
    onError: () => {
      errorMessage("فاکتور با مشکل مواجه شده است");
    },
  });

// get all order offline
// export const useGetAllOrderOnline = (IdEquivalentOrderOffline) => {
//   return useQuery(
//     "order-online",
//     () => getAllOrderOffline(IdEquivalentOrderOffline),
//     {
//       enabled: true,
//     }
//   );
// };

// get all order online

export const useGetAllOrderOnline = (IdEquivalentOrderOffline) =>
  useQuery(["order-online", IdEquivalentOrderOffline], () =>
    getAllOrderOffline(IdEquivalentOrderOffline)
  );

// insert detail order product
export const useFinalConfirmFactor = () =>
  useMutation(finalConfirm, {
    onSuccess: () => {
      successMessage("پیش فاکتور با موفقیت ثبت شد");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });

// get final print preInvoice
export const useGetFinalPrint = (factorData, isFactor) =>
  useQuery(["factor", factorData], () =>
    isFactor === "true" ? getFactor(factorData) : getFinalPrint(factorData)
  );
// get final print factor
// export const useGetFactor = (factorData) =>
//   useQuery(["factor", factorData], () => getFactor(factorData));

// //

// ---------------------------------List preInvoice

// get list preInvoice
export const useGetListPreInvoice = (pageNumber) =>
  useQuery(["preInvoice", pageNumber], () => getListPreInvoice(pageNumber));

// delete a preInvoice
export const useRemovePreInvoice = () =>
  useMutation(deletePreInvoice, {
    onSuccess: () => {
      successMessage("با موفقیت حذف شد");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });

// ConversionToFactor
export const useConversionToFactor = () =>
  useMutation(conversionToFactor, {
    onSuccess: () => {
      successMessage("با موفقیت به فاکتور فروش تبدیل شد");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });

// search in preInvoice
export const useSearchPreInvoice = (searchData) =>
  useQuery(["preInvoice", searchData], () => searchPreInvoice(searchData));

// -----------------------------------Check Service------------------------------
// get all checklist
export const useGetCheckList = (status) =>
  useQuery(["all-check", status], () => {
    if (status === "چک های اول دوره") {
      return getAllCheckList();
    } else if (status === "چک های موجود") {
      return getAvaiableCheck();
    } else if (status === "کلیه چک ها") {
      return getAllOfChecks();
    } else if (status === "چک های پرداختی") {
      return getBackCheck();
    }
  });

export const useRecieveChecklist = () =>
  useQuery("list-recieve", getListRecieveChecklist);

export const usePaymentChecklist = () =>
  useQuery("list-payment", getListPaymentChecklist);

// // get available checks
// export const useGetAvaialbleCheck = () =>
//   useQuery("available-check", getAvaiableCheck, {
//     enabled: false,
//   });

// add a new check
export const useAddNewCheck = () =>
  useMutation(addNewCheck, {
    onSuccess: () => {
      successMessage("با موفقیت ساخته شد");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });
// add check back payment
export const useAddCheckPayment = () =>
  useMutation(addNewCheckBack, {
    onSuccess: () => {
      successMessage("با موفقیت ساخته شد");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });

export const useUpdateCheckSell = () => {
  return useMutation(updateCheckSell, {
    onSuccess: () => {
      successMessage("با موفقیت ساخته شد");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });
};

// update a check
export const useUpdateCheck = () =>
  useMutation(updatePurchaseCheck, {
    onSuccess: () => {
      successMessage("با موفقیت آپدیت شد");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });

// delete a check
export const useDeleteCheck = () =>
  useMutation(deleteCheck, {
    onSuccess: () => {
      successMessage("با موفقیت انجام شد");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });

// ------------------------------------Factor Service----------------------------
// get all list document factor
export const useGetListDocumentFactor = (IdEquivalentOrder) =>
  useQuery(["all-document-factor", IdEquivalentOrder], () =>
    getListDocumentFactor(IdEquivalentOrder)
  );

// add factor naghdi
export const useAddNaghdiFactor = () =>
  useMutation(addNaghdiFactor, {
    onSuccess: () => {
      successMessage("با موفیت اضافه شد");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });

// update naghdi factor
export const useUpdatenaghdiFactor = () =>
  useMutation(updateNaghdiFactor, {
    onSuccess: () => {
      successMessage("با موفقیت آپدیت شد");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });

// confirm factor
export const useConfirmFactor = () => useMutation(confirmFactor);

// add check factor
export const useAddCheckFactor = () =>
  useMutation(addCheckFactor, {
    onSuccess: () => {
      successMessage("با موفقیت ثبت شد");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });

// update check factor
export const useUpdateCheckFactor = () =>
  useMutation(updateCheckFactor, {
    onSuccess: () => {
      successMessage("با موفقیت حذف شد");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });

// delete sanad daryaft
export const useDeleteSanadDaryaft = () =>
  useMutation(deleteSandadDaryaft, {
    onSuccess: () => {
      successMessage("با موفقیت حذف شد");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });

export const useDeletePaymentSell = () => {
  const queryClient = useQueryClient();
  return useMutation(deleteCheckPaymentSell, {
    onSuccess: () => {
      successMessage("با موفقیت آپدیت شد");
      queryClient.invalidateQueries("list-operation-sell");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });
};

// get all list of factor
export const useGetListFactor = (PageNumber) =>
  useQuery(["all-factor", PageNumber], () => getAllFactor(PageNumber));

// update havale
export const useUpdateHavale = () =>
  useMutation(updateHavale, {
    onSuccess: () => {
      successMessage("با موفقیت آپدیت شد");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });

export const useUpdateNaghdiCheck = () => {
  return useMutation(updateNaghdiCheck, {
    onSuccess: () => {
      successMessage("با موفقیت آپدیت شد");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });
};

export const useUpdateHavaleCheck = () => {
  const queryClient = useQueryClient();
  return useMutation(updateHavaleCheck, {
    onSuccess: () => {
      successMessage("با موفقیت آپدیت شد");
      queryClient.invalidateQueries("list-recieve-operation");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });
};

// update havale variz
export const useUpdateCardkhan = () => useMutation(updateCardkhan);

// ------------------------------Anbar Service------------------------------
// get user list anbar
export const useListAnbar = () => useQuery("list-anbar", getListAnbar);
// add new anbar
export const useAddAnbar = () =>
  useMutation(addNewAnbar, {
    onSuccess: () => {
      successMessage("با موفقیت اضافه شد");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });
// update anbar
export const useUpdateAnbar = () =>
  useMutation(updateAnbar, {
    onSuccess: () => {
      successMessage("با موفقیت آپدیت شد");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });
// delete anbar
export const useDeleteAnbar = () =>
  useMutation(deleteAnbar, {
    onSuccess: () => {
      successMessage("با موفقیت حذف شد");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });

// -------------------------------------cost service--------------------
// add new cost
export const useAddCost = () =>
  useMutation(addCost, {
    onSuccess: () => {
      successMessage("درج هزینه با موفقیت انجام شد");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });
// get all cost
export const useGetCost = () => useQuery("list-cost", getAllCost);
// delete a cost
export const useDeleteCost = () =>
  useMutation(deleteCost, {
    onSuccess: () => {
      successMessage("با موفقیت حذف شد");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });
// update cost
export const useUpdateCost = () =>
  useMutation(updateCost, {
    onSuccess: () => {
      successMessage("با موفقیت آپدیت شد");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });
// ------------------------income service-------------------------------
// get all income
export const useGetIncome = () =>
  useQuery("income-list", () => getAllIcomeList());
// add new income
export const useAddIncome = () =>
  useMutation(addNewIncome, {
    onSuccess: () => {
      successMessage("با موفقیت اضافه شد");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });
// delete income
export const useDeleteIncome = () =>
  useMutation(deleteIncome, {
    onSuccess: () => {
      successMessage("با موفقیت حذف شد");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });
// update income
export const useUpdateIncome = () => useMutation(updateIncome);

// ---------------------------------servuce return sales --------------------
export const useGetOrderOfflineAndOrderOnline = (IdPerson) =>
  useQuery(["orderOffline-orderOnline", IdPerson], () =>
    getListOrderOfflinesAndListOrderOnlines(IdPerson)
  );

export const useAddInsertReturnSale = () =>
  useMutation(returnOnSale, {
    onSuccess: () => {
      successMessage("با موفقیت انجام شد");
    },
    onError: () => {
      errorMessage("خطا در سرور");
    },
  });

// show list return on sale
export const useListReturnOnSale = (IdEquivalentReturnOnSales) =>
  useQuery(["list-return-on-sale", IdEquivalentReturnOnSales], () =>
    getListReturnOnSale(IdEquivalentReturnOnSales)
  );

// delete order online and offline
export const useDeleteOrderReturnOnSale = () => {
  const queryClient = useQueryClient();
  return useMutation(deleteOrderReturnOnSale, {
    onSuccess: () => {
      successMessage("با موفقیت حذف شد");
      queryClient.invalidateQueries("list-return-on-sale");
    },
    onError: () => {
      errorMessage("خطا در سرور");
    },
  });
};

// confirm Return On Sale
export const useConfirmReturnOnSale = () =>
  useMutation(confirmReturnOnSale, {
    onSuccess: () => {
      successMessage("با موفقیت تایید شد");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });

// edit return on sale
export const useEditReturnOnSale = () => {
  const queryClient = useQueryClient();
  return useMutation(editReturnOnSale, {
    onSuccess: () => {
      successMessage("با موفقیت آپدیت شد");
      queryClient.invalidateQueries("list-return-on-sale");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });
};

// list return sale
export const useGetListReturnOnSale = () =>
  useQuery("list-order-return", listReturnOnSale);

// -----------------------purchase invoice----------------
export const useGetListSupplire = () =>
  useInfiniteQuery(
    "list-supplire",
    ({ pageParam = 1 }) => getSupplierList(pageParam),
    {
      getNextPageParam: (lastPage, allPages) => {
        return allPages.length + 1;
      },
    }
  );

export const useAddPurchaseFactorCustom = () =>
  useMutation(addFactorPurchaseCustom, {
    onSuccess: () => {
      successMessage("عملیات با موفقیت انجام شد");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });

export const useGetListPuchaseFactorCustom = (IdEquivalentFactorBuys) =>
  useQuery(["list-purchase-factor-custom", IdEquivalentFactorBuys], () =>
    getListPurchaceFactorCustom(IdEquivalentFactorBuys)
  );

export const useAddFactorPurchaseNaghdi = () => {
  const queryClient = useQueryClient();

  return useMutation(addNaghdiFactorPurchase, {
    onSuccess: () => {
      successMessage("عملیات با موفقیت انجام شد");
      queryClient.invalidateQueries("list-purchase");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });
};

export const useAddFactorPurchaseHavale = () => {
  const queryClient = useQueryClient();
  return useMutation(addHavaleFactorPurchase, {
    onSuccess: () => {
      successMessage("عملیات با موفقیت انجام شد");
      queryClient.invalidateQueries("list-purchase");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });
};

export const useAddFactorPurchaseCartkhan = () => {
  const queryClient = useQueryClient();
  return useMutation(addCartkhanFactorPurchase, {
    onSuccess: () => {
      successMessage("عملیات با موفقیت انجام شد");
      queryClient.invalidateQueries("list-purchase");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });
};

export const useAddFactorPurchaseCheck = () => {
  const queryClient = useQueryClient();
  return useMutation(addCheckFactorPurchase, {
    onSuccess: () => {
      successMessage("عملیات با موفقیت انجام شد");
      queryClient.invalidateQueries("list-purchase");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });
};

export const useGetPurchaseList = (IdEquivalentFactorBuys) =>
  useQuery("list-purchase", () => getListPurchase(IdEquivalentFactorBuys));

export const useFinalPurchaseFactor = () => {
  return useMutation(finalConformPurchaseCutom, {
    onSuccess: () => {
      successMessage("عملیات با موفقیت انجام شد");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });
};

export const useUpdatePurchaseNaghdi = () => {
  const queryClient = useQueryClient();

  return useMutation(updatePurchasenaghdi, {
    onSuccess: () => {
      successMessage("عملیات باموفقیت انجام شد");
      queryClient.invalidateQueries("list-purchase");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });
};

export const useUpdatePurchaseCheck = () => {
  const queryClient = useQueryClient();
  return useMutation(updatePurchaseCheck, {
    onSuccess: () => {
      successMessage("عملیات باموفقیت انجام شد");
      queryClient.invalidateQueries("list-purchase");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });
};

export const useUpdatePurchasCartkhab = () => {
  const queryClient = useQueryClient();
  return useMutation(updatePurchaseCartkhan, {
    onSuccess: () => {
      successMessage("عملیات با موفقیت انجام شد");
      queryClient.invalidateQueries("list-purchase");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });
};

export const useUpdatePurchaseHavale = () => {
  const queryClient = useQueryClient();
  return useMutation(updatePurchaseHavale, {
    onSuccess: () => {
      successMessage("عملیات باموفقیت انجام شد");
      queryClient.invalidateQueries("list-purchase");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });
};

export const useDeletePurchaseItem = () => {
  const queryClient = useQueryClient();

  return useMutation(deletePurchaseItem, {
    onSuccess: () => {
      successMessage("عملیات باموفقیت انجام شد");
      queryClient.invalidateQueries("list-purchase");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });
};

export const useGetResponseCheck = () =>
  useMutation(getResponeCheck, {
    onSuccess: () => {
      successMessage("عملیات با موفقیت انجام شد");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });

export const useAddFactorAutoPurchase = () => {
  return useMutation(addFactorAutoPurchase, {
    onSuccess: () => {
      successMessage("عملیات با موفقیت انجام شد");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });
};

export const useGetFactorPurchase = () => {
  return useQuery("list-factor-purcahse", getListFactorPurchase);
};

export const useDeletePurchaseProduct = () => {
  const queryClient = useQueryClient();
  return useMutation(deletePurchaseProduct, {
    onSuccess: () => {
      successMessage("عملیات با موفقیت انجام شد");
      queryClient.invalidateQueries("ist-purchase-factor-custom");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });
};

export const useUpdatePurchaseProduct = () => {
  return useMutation(updatePurchaseProduct, {
    onSuccess: () => {
      successMessage("عملیات با موفقیت انجام شد");
      // queryClient.invalidateQueries("ist-purchase-factor-custom");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });
};

// ---------------------Operation Sell----------------------
export const useGetListOperationSell = () =>
  useInfiniteQuery(
    "list-operation-sell",
    ({ pageParam = 1 }) => getListSellPayment(pageParam),
    {
      getNextPageParam: (lastPage, allPages) => {
        return allPages.length + 1;
      },
    }
  );

export const useAddCheckSell = () => {
  const queryClient = useQueryClient();
  return useMutation(addCheckPaymentSell, {
    onSuccess: () => {
      successMessage("عملیات با موفقیت انجام شد");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });
};

export const useGetCashDetails = (cashId) =>
  useQuery(["cash-details", cashId], () => getCashDetail(cashId));

export const useGetBankDetails = (bankId) =>
  useQuery(["bank-details", bankId], () => getBankDetail(bankId));

export const useGetCheckDetails = () =>
  useQuery("check-received-details", () => getCheckDetail());

export const useGetCheckPaidDetails = () =>
  useQuery("check-paid-details", () => getCheckPaidDetail());

export const useGetListOperation = () =>
  useInfiniteQuery(
    "list-operation",
    ({ pageParam = 1 }) => getListOperation(pageParam),
    {
      getNextPageParam: (lastPage, allPages) => {
        return allPages.length + 1;
      },
    }
  );

export const useGetUpdateCheck = () => {
  return useMutation(getCheckUpdate, {
    onSuccess: () => {
      successMessage("عملیات با موفقیت انجام شد");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });
};

export const useCheckChange = () => {
  const queryClient = useQueryClient();

  return useMutation(changeCheckStatus, {
    onSuccess: () => {
      successMessage("عملیات با موفقیت انجام شد");
      queryClient.invalidateQueries("list-recieve");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });
};

export const useChangePayment = () => {
  return useMutation(changeCheckStatus, {
    onSuccess: () => {
      successMessage("عملیات با موفقیت انجام شد");
      //  queryClient.invalidateQueries("list-recieve");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });
};

// --------------------------payment operation---------------------
export const useAddCheckPaymentOperation = () => {
  const queryClient = useQueryClient();

  return useMutation(addCheckPaymentOperation, {
    onSuccess: () => {
      successMessage("عملیات با موفقیت انجام شد");
      queryClient.invalidateQueries("getListPaymentOperation");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });
};

export const useAddNaghdiPaymetnOperation = () => {
  const queryClient = useQueryClient();

  return useMutation(addNaghdiPaymentOperation, {
    onSuccess: () => {
      successMessage("عملیات با موفقیت انجام شد");
      queryClient.invalidateQueries("getListPaymentOperation");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });
};

export const useAddCartkhanPaymentOperation = () => {
  const queryClient = useQueryClient();

  return useMutation(addCartkhanPaymentOperation, {
    onSuccess: () => {
      successMessage("عملیات با موفقیت انجام شد");
      queryClient.invalidateQueries("getListPaymentOperation");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });
};

export const useAddHavalePaymentOperation = () => {
  const queryClient = useQueryClient();

  return useMutation(addHavalePaymentOperation, {
    onSuccess: () => {
      successMessage("عملیات با موفقیت انجام شد");
      queryClient.invalidateQueries("getListPaymentOperation");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });
};

export const useGetListPaymentOperation = (IdUserForPaymentOperation) => {
  return useQuery(["getListPaymentOperation", IdUserForPaymentOperation], () =>
    getListPaymentOperation(IdUserForPaymentOperation)
  );
};

export const useDeleteItemPaymentOperation = () => {
  const queryClient = useQueryClient();

  return useMutation(deletePaymentItemOperation, {
    onSuccess: () => {
      successMessage("عملیات با موفقیت انجام شد");
      queryClient.invalidateQueries("getListPaymentOperation");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });
};

export const useUpdatePaymentOperation = () => {
  const queryClient = useQueryClient();
  return useMutation(updateNaghdiPaymentOperation, {
    onSuccess: () => {
      successMessage("عملیات با موفقیت انجام شد");
      queryClient.invalidateQueries("getListPaymentOperation");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });
};

export const useAddFactorNaghdi = () => {
  const queryClient = useQueryClient();
  return useMutation(recieveOperation, {
    onSuccess: () => {
      successMessage("عملیات با موفقیت انجام شد");
      queryClient.invalidateQueries("list-recieve-operation");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });
};

export const useGetDetailRecieveOperation = (IdUserForResiveOperation) =>
  useQuery(["list-recieve-operation", IdUserForResiveOperation], () =>
    detailRecieveOperation(IdUserForResiveOperation)
  );

export const useAddFactorCheckRecieveOperation = () => {
  const queryClient = useQueryClient();

  return useMutation(addCheckRecieveOperation, {
    onSuccess: () => {
      successMessage("عملیات با موفقیت انجام شد");
      queryClient.invalidateQueries("list-recieve-operation");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });
};

export const useAddFactorHavaleRecieveOperation = () => {
  const queryClient = useQueryClient();

  return useMutation(addHavaleRecieveOperation, {
    onSuccess: () => {
      successMessage("عملیات با موفقیت انجام شد");
      queryClient.invalidateQueries("list-recieve-operation");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });
};

export const useAddFactorCartkhanRecieveOperation = () => {
  const queryClient = useQueryClient();

  return useMutation(addCartkhanRecieveOperation, {
    onSuccess: () => {
      successMessage("عملیات با موفقیت انجام شد");
      queryClient.invalidateQueries("list-recieve-operation");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });
};

export const useDeleteFactorRecieve = () => {
  const queryClient = useQueryClient();
  return useMutation(deleteFactorItemRecievePayment, {
    onSuccess: () => {
      successMessage("عملیات با موفقیت انجام شد");
      queryClient.invalidateQueries("list-recieve-operation");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });
};

export const useGetDashboard = () => useQuery("dashoard", getDashboard);

// ---------------------------Havale Hesab---------------------------
export const useGetHavaleHesab = () =>
  useQuery("list-havale-hesab", getListHavaleHesab);

export const useGetAccessHavaleStatus = () =>
  useQuery("access-list-havale-status", getAccessHavaleStatus);

export const useGetAllUsers = (PageNumber) =>
  useInfiniteQuery(
    ["list-user", PageNumber],
    ({ pageParam = 1 }) => listUser(pageParam),
    {
      getNextPageParam: (lastPage, allPages) => {
        return allPages.length + 1;
      },
    }
  );

export const useInsertHavaleHesab = () => {
  return useMutation(addHavaleHesab, {
    onSuccess: () => {
      successMessage("عملیات با موفقیت انجام شد");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });
};
// useQuery(["list-user", PageNumber], () => listUser(PageNumber), {
//   keepPreviousData: true,
//   staleTime: 5000,
// });

export const useNonPortalPayment = () => {
  const queryClient = useQueryClient();
  return useMutation(nonPortalPayment, {
    onSuccess: () => {
      queryClient.invalidateQueries("payment-online-order");
      successMessage("پرداخت با موفقیت انجام شد");
    },
    onError: () => {
      errorMessage("عملیات با خطا مواجه شد");
    },
  });
};

export const useGetListSms = () =>
  useQuery("list-manament-sms", getListSmsManagement);

export const useChangeStatusSms = () => {
  return useMutation(changeStatusSmsList, {
    onSuccess: () => {
      successMessage("عملیات با موفقیت انجام شد");
    },
    onError: () => {
      errorMessage("عملیات با خطا مواجه شد");
    },
  });
};

export const useDetailSms = (id) => {
  return useQuery("get-detail-sms", () => getDetailSmsManagement(id));
};

export const useUpdateSms = () => {
  return useMutation(updateSmsPanel, {
    onSuccess: () => {
      successMessage("عملیات با موفقیت انجام شد");
    },
    onError: () => {
      errorMessage("عملیات ناموفق انجام شد");
    },
  });
};

export const useDeleteNotConfirmedOrderOnlien = () => {
  const queryClient = useQueryClient();
  return useMutation(deleteNotConfirmedOrderOnline, {
    onSuccess: () => {
      queryClient.invalidateQueries("approve-online-order");
      queryClient.invalidateQueries("payment-online-order");
      successMessage("سفارش با موفقیت حذف شد");
    },
    onError: () => {
      errorMessage("عملیات با خطا مواجه شد");
    },
  });
};
